import AnnouncementCustomService from "../../../../services/abstract/announcements/AnnouncementCustomService";
import AnnouncementCustomServiceApi from "../../../../services/api/announcements/AnnouncementCustomServiceApi";
import { OK } from "http-status-codes";
import React from "react";
import RecomendedAnnouncements from "../../../../components/announcement/lists/recomended/RecomendedAnnouncements";
import SMessage from "../../../../struct/message/SMessage";
import { addMessage } from "../../../../store/actions/messages";
import store from "../../../../store/store";

interface Props {}
interface State {
  loading: boolean;
  announcements: Array<App.Announcement.Announcement>;
}

class RecomendedAnnouncementsContainer extends React.Component<Props, State> {
  private service: AnnouncementCustomService;
  constructor(props: Props) {
    super(props);
    this.state = {
      loading: false,
      announcements: [],
    };
    this.service = new AnnouncementCustomServiceApi();
  }

  public componentDidMount() {
    this.getAnnouncements();
  }

  public async getAnnouncements() {
    this.setState({ loading: true });
    const { data, status } = await this.service.getRecomended();
    if (status === OK) {
      this.setState({ loading: false, announcements: data });
    } else {
      store.dispatch(
        addMessage(
          new SMessage("Не удалось загрузить список рекомендованных объявлений")
        )
      );
      this.setState({ loading: false });
    }
  }

  public render() {
    return (
      <RecomendedAnnouncements
        announcements={this.state.announcements}
        loading={this.state.loading}
      />
    );
  }
}

export default RecomendedAnnouncementsContainer;
